import { authFetch } from "@/api/authFetch.ts"
import { API_BASE } from "@/config.ts"

import type { DataPointReport } from "../../types/reportTypes.ts"

export const addReport = async (report: DataPointReport) => {
  await authFetch(`${API_BASE}/reports`, {
    method: "POST",
    body: JSON.stringify(report),
    headers: {
      "Content-Type": "application/json",
    },
  })
}
